var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('ContactLineForm',{attrs:{"channels":_vm.localValues.channels,"entities":_vm.localValues.entities,"isEdit":false,"initialValues":_vm.initialValues,"onCancel":_vm.handleCancel,"onSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between flex-wrap"},[_c('h3',{staticClass:"title mb-6"},[_vm._v("Nieuwe contactlijn toevoegen")])])
}]

export { render, staticRenderFns }